import { Grid, Typography } from '@mui/material';
import { useQuery } from 'react-query';
import { Task } from '../../../../../../types/api';
import { useAuth } from '../../../hooks';
import { listAccountContactsActivityAPI } from '../../../services/apis';
import theme from '../../../theme';
import { formatDatetime } from '../../../utils/formatters';
import ResponsibleModal from '../../ResponsibleModal';

type Props = {
  open: boolean;
  onClose: () => void;
};

export default function ActivityLogModal({ open, onClose }: Props) {
  const { user } = useAuth();
  const { data: tasks } = useQuery<Task[]>(
    ['activity', user?.account.id],
    async () => (user?.account.id ? listAccountContactsActivityAPI() : []),
    { enabled: !!user?.account.id, refetchOnWindowFocus: false }
  );

  return (
    <ResponsibleModal
      open={open}
      onClose={onClose}
      title="Activity Log"
      description="All activity for your team is displayed here"
    >
      <Grid
        container
        sx={{
          backgroundColor: '#F9FBFD',
          border: `1px solid ${theme.palette.border.input}`,
          borderRadius: 0.5,
          p: 2,
          overflowWrap: 'anywhere',
        }}
        gap={1.5}
      >
        {tasks
          ?.sort(
            (a, b) =>
              new Date(b.created_date || '').getTime() -
              new Date(a.created_date || '').getTime()
          )
          .map((task) => (
            <Grid container item key={task.id}>
              <Grid item xs={12} md={4}>
                <Typography variant="body2" color="text.secondary">
                  {formatDatetime(task.created_date)}
                </Typography>
              </Grid>

              <Grid item xs={12} md={8}>
                <Typography variant="body1" fontWeight={700}>
                  {task.description}
                </Typography>
              </Grid>
            </Grid>
          ))}
      </Grid>
    </ResponsibleModal>
  );
}
